<template>
    <div>
        <div style="background: #fff;margin-top: 20px;">
            <p class="search-title">查询条件</p>
            <div class="search-list">
                <div v-if="waybillNos.length>0"
                   style="color: #333;background: #f5f5f5;
            padding: 6px 8px;
            border-radius: 4px;
            margin-bottom: 4px;">
                    <div>单号：
                        <p style="width: calc(100% - 90px);display: inline-block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align: top;">
                        <b style="font-weight: normal;margin-right: 4px;" v-for="(item,index) in waybillNos" :key="index">{{item}}</b>
                        </p>
                        等{{waybillNos.length}}项
                    </div>
                </div>
                <p v-if="search.startTime && search.endTime"><span>寄件日期：{{search.startTime}}至{{search.endTime}}</span>

                </p>
            </div>
        </div>
        <div v-show="result.length===0">
            <p style="text-align: center;margin-top: 10px;color: #999;font-size: 14px;">没有数据</p>
        </div>
        <div
                v-infinite-scroll="loadMore"
                infinite-scroll-disabled="loading"
                infinite-scroll-immediate-check="false"
                infinite-scroll-distance="20">
            <div class="result" v-if="result.length !== 0">
                <div class="padded info" v-for="(item, index) in result" :key="index">
                    <div class="clearfix">
                        <p class="fl">订单号码<span>{{item.orderNo}}</span></p>
                        <span class="fr" style="color: #19a0ff;"
                              @click="$router.push({name: 'OrderDesc',query: {transNo: item.waybillNo, status: item.status, createTime: item.createTime, checkTime: item.checkTime}})">详情</span>
                    </div>
                    <p>参考编号<span>{{item.refNo}}</span></p>
                    <p>运单号码<span>{{item.waybillNo}}</span></p>
                    <p>转单号码<span style="color: red;">{{item.transNo}}</span></p>
                    <p>订单状态<span>{{['待审核','待补录','待交寄','待出货','运输中','已完成','已取消','待修正','已签收'][item.status-1]}}</span></p>
                    <p>寄件日期<span>{{dateFormat(item.createTime)}}</span></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Order',
        data() {
            return {
                search: {
                    pageIndex: 1,
                    pageSize: 10,
                    queryNos: '',
                },
                loading: false,
                waybillNos: [],
                result: []
            }
        },
        created() {
            this.search.startTime = this.$route.query.startTime;
            this.search.endTime = this.$route.query.endTime;
            this.search.queryNos = this.$route.query.queryNos || '';
            let queryNos = this.search.queryNos ? this.search.queryNos.replace(/\n/g, ',') : '';
            const waybillNos = queryNos?queryNos.split(','):[];
            this.waybillNos = [];
            for (let i = 0;i<waybillNos.length;i++) {
                let waybillNoItem = waybillNos[i].replace(/\s/g,'');
                if (waybillNoItem) {
                    this.waybillNos.push(waybillNoItem);
                }
            }
            this.searchData();
        },
        activated() {
            this.search.startTime = this.$route.query.startTime;
            this.search.endTime = this.$route.query.endTime;
            this.search.queryNos = this.$route.query.queryNos || '';
            let queryNos = this.search.queryNos ? this.search.queryNos.replace(/\n/g, ',') : '';
            const waybillNos = queryNos?queryNos.split(','):[];
            this.waybillNos = [];
            for (let i = 0;i<waybillNos.length;i++) {
                let waybillNoItem = waybillNos[i].replace(/\s/g,'');
                if (waybillNoItem) {
                    this.waybillNos.push(waybillNoItem);
                }
            }
            this.searchData();
        },
        methods: {
            dateFormat(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                if (month < 10) {
                    month = '0' + month;
                }
                var day = date.getDate();
                if (day < 10) {
                    day = '0' + day;
                }
                return year + '-' + month + '-' + day;
            },
            searchData() {
                if (this.loading) return false;
                this.result = [];
                this.getData();
            },
            getData(pageIndex = 1, pageSize = 10) {
                this.loading = true;
                this.$indicator.open({
                    spinnerType: 'fading-circle'
                });
                this.search.pageIndex = parseInt(pageIndex);
                this.search.pageSize = parseInt(pageSize);
                let companyNo = this.$util.get("companyNo");
                this.search.customerCode  = this.$util.get(companyNo+"_userInfo").clientNo || "";
                this.http.send({command: 'order/getOrderList', params: this.search}).then(res => {
                    this.loading = false;
                    this.$indicator.close();
                    this.total = res.data.body.count;
                    this.result = this.result.concat(res.data.body.datas || []);
                }).catch(err => {
                    this.loading = false;
                    this.$indicator.close();
                })
            },
            loadMore() {
                if (this.loading) return false;
                if (this.total === this.result.length) return false;
                this.search.pageIndex++;
                this.getData(this.search.pageIndex);
            },
        }
    }
</script>
<style lang="less" scoped>
    .search-title {
        padding-top: 10px;
        text-align: center;
        color: #333;
        font-size: 16px;
    }
    .search-list {
        padding: 10px 10px 20px;
        font-size: 12px;
        span {
            color: #333;
            background: #f5f5f5;
            padding: 6px 8px;
            border-radius: 4px;
            margin-bottom: 4px;
            display: inline-block;
        }
    }
    .result {
        margin-top: 20px;
        .info {
            background: #fff;
            margin-top: 8px;
            padding-bottom: 10px;
            padding-top: 10px;
            p {
                line-height: 30px;
                span {
                    margin-left: 8px;
                    color: #666666;
                    font-size: 14px;
                    line-height: 24px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/order/order.vue